import { useMemo } from 'react'
import { useDocument, useLoading } from 'hooks'
import {} from 'domains/Platform/hooks'

const useGetPlatformInitialValues = (id) => {
  // [DATA_FETCH]
  const [platform, platformLoading] = useDocument({
    ref: id ? `platforms/${id}` : null
  })

  // [COMPUTED_PROPERTIES]
  const initialValues = useMemo(
    () => ({
      platform
    }),
    [platform]
  )
  const loadings = useMemo(
    () => (id ? [!platform, platformLoading] : []),
    [id, platform, platformLoading]
  )

  // [ADDITIONAL_HOOKS]
  const loading = useLoading(loadings)

  return [initialValues, loading]
}

export default useGetPlatformInitialValues
